module.exports = __webpack_public_path__ + "media/images/icons/close-e6cb26f45b836a20978824855f036277.png";